import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const TechnicalInfoAISkeleton = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={style.blockHead}>
        <div className={style.blockTitle} id="tourStep-13">
          {t('Technical information')}
        </div>
      </div>
      <div className={style.blockContainer}>
        <div className={style.actionItemHead}>
          <SkeletonBlock className={style.skeletonStatusLabel} />
          <SkeletonBlock className={style.skeletonLabel} />
        </div>
        <div className={style.extraInformation}>
          <SkeletonBlock className={style.skeletonDevice} />
          {[...Array(3)].map((_) => (
            <SkeletonBlock key={uuidv4()} className={style.skeletonInfoField} />
          ))}
        </div>
        <div className={style.mainInformation}>
          {[...Array(6)].map((_) => (
            <SkeletonBlock key={uuidv4()} className={style.skeletonInfoField} />
          ))}
        </div>
        <SkeletonBlock className={style.skeletonButton} />
        <div className={style.galleryBlock}>
          <SkeletonBlock className={style.skeletonGallery} />
        </div>
      </div>
    </div>
  );
};

export default TechnicalInfoAISkeleton;
